// extracted by mini-css-extract-plugin
export var postSidebar = "style-module--post-sidebar--f6162";
export var postSidebarBottom = "style-module--post-sidebar--bottom--54b5b";
export var postSidebarFixed = "style-module--post-sidebar--fixed--79452";
export var postSidebar__cta = "style-module--post-sidebar__cta--74ec3";
export var postSidebar__ctaBtn = "style-module--post-sidebar__ctaBtn--30909";
export var postSidebar__ctaBtnOuter = "style-module--post-sidebar__ctaBtnOuter--f2121";
export var postSidebar__ctaBtnWrap = "style-module--post-sidebar__ctaBtnWrap--4be9b";
export var postSidebar__ctaButton = "style-module--post-sidebar__ctaButton--778ee";
export var postSidebar__ctaCard = "style-module--post-sidebar__ctaCard--4a146";
export var postSidebar__ctaImage = "style-module--post-sidebar__ctaImage--394fb";
export var postSidebar__ctaTitle = "style-module--post-sidebar__ctaTitle--77a27";
export var postSidebar__ctaTitleMob = "style-module--post-sidebar__ctaTitleMob--12524";
export var postSidebar__imgBtn = "style-module--post-sidebar__imgBtn--f73df";
export var postSidebar__link = "style-module--post-sidebar__link--84ada";
export var postSidebar__linkActive = "style-module--post-sidebar__link--active--93c83";
export var postSidebar__links = "style-module--post-sidebar__links--717b3";
export var postSidebar__sidebarSticky = "style-module--post-sidebar__sidebarSticky--af418";
export var postSidebar__title = "style-module--post-sidebar__title--8ad89";
export var postSidebar__titleWrap = "style-module--post-sidebar__titleWrap--3cd16";
export var postSidebar__toc = "style-module--post-sidebar__toc--0cad6";
export var postSidebar__tocClose = "style-module--post-sidebar__tocClose--767f5";
export var postSidebar__tocFixedMobile = "style-module--post-sidebar__tocFixedMobile--9e3c4";
export var postSidebar__tocHeightHigh = "style-module--post-sidebar__tocHeightHigh--84f7b";
export var postSidebar__tocHeightSmall = "style-module--post-sidebar__tocHeightSmall--5369b";